import {PageLink} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'

export const digitalBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Digital Signing',
    path: '/digital-signing',
    isSeparator: true,
    isActive: false,
  },
]

export const digitalViewBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Digital Signing',
    path: '/digital-signing?tabKey=2',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const DigitalSigningBreadCrumbs = () => {
  const {formatMessage} = useIntl()
  const digitalBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Digital Signing'}),
      path: '/digital-signing',
      isSeparator: true,
      isActive: false,
    },
  ]

  const digitalViewBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Digital Signing'}),
      path: '/digital-signing?tabKey=2',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return {
    digitalBreadCrumbs,
    digitalViewBreadCrumbs,
  }
}

export enum TemplateTypes {
  NDA = 'NDA',
  AGREEMENT = 'Agreement',
  NOTICE = 'Notice',
  TERMSHEET = 'Termsheet',
  POLICY = 'Policy',
  MOU = 'MoU',
  OTHERS = 'Others',
}

export const TemplateTypeOptions = [
  {
    id: 1,
    label: TemplateTypes.NDA,
    value: TemplateTypes.NDA,
  },
  {
    id: 2,
    label: TemplateTypes.AGREEMENT,
    value: TemplateTypes.AGREEMENT,
  },
  {
    id: 3,
    label: TemplateTypes.NOTICE,
    value: TemplateTypes.NOTICE,
  },
  {
    id: 4,
    label: TemplateTypes.TERMSHEET,
    value: TemplateTypes.TERMSHEET,
  },
  {
    id: 5,
    label: TemplateTypes.POLICY,
    value: TemplateTypes.POLICY,
  },
  {
    id: 6,
    label: TemplateTypes.MOU,
    value: TemplateTypes.MOU,
  },
  {
    id: 7,
    label: TemplateTypes.OTHERS,
    value: TemplateTypes.OTHERS,
  },
]

export enum DocumentSubmissionStatus {
  AWAITING = 'Awaiting',
  OVERDUE = 'Overdue',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
  EXPIRED = 'Expired',
}

export enum SignatureTypes {
  WAITING_FOR_YOU = 'Waiting for You',
  WAITING_FOR_OTHERS = 'Waiting for Others',
}

export const DocumentsStatusOptions = [
  {
    id: 1,
    label: DocumentSubmissionStatus.AWAITING,
    value: DocumentSubmissionStatus.AWAITING,
  },
  {
    id: 2,
    label: DocumentSubmissionStatus.OVERDUE,
    value: DocumentSubmissionStatus.OVERDUE,
  },
  {
    id: 3,
    label: DocumentSubmissionStatus.COMPLETED,
    value: DocumentSubmissionStatus.COMPLETED,
  },
  {
    id: 4,
    label: DocumentSubmissionStatus.CANCELLED,
    value: DocumentSubmissionStatus.CANCELLED,
  },
]

export const DocumentsSignatureStatusOptions = [
  {
    id: 1,
    label: SignatureTypes.WAITING_FOR_YOU,
    value: SignatureTypes.WAITING_FOR_YOU,
  },
  {
    id: 2,
    label: SignatureTypes.WAITING_FOR_OTHERS,
    value: SignatureTypes.WAITING_FOR_OTHERS,
  },
]

export const DigitalSigningFilter = () => {
  const {formatMessage} = useIntl()

  const TemplateTypes = {
    NDA: formatMessage({id: 'NDA'}),
    AGREEMENT: formatMessage({id: 'Agreement'}),
    NOTICE: formatMessage({id: 'Notice'}),
    TERMSHEET: formatMessage({id: 'Termsheet'}),
    POLICY: formatMessage({id: 'Policy'}),
    MOU: formatMessage({id: 'MoU'}),
    OTHERS: formatMessage({id: 'Others'}),
  } as const

  const TemplateTypeOptions = [
    {
      id: 1,
      label: TemplateTypes.NDA,
      value: TemplateTypes.NDA,
    },
    {
      id: 2,
      label: TemplateTypes.AGREEMENT,
      value: TemplateTypes.AGREEMENT,
    },
    {
      id: 3,
      label: TemplateTypes.NOTICE,
      value: TemplateTypes.NOTICE,
    },
    {
      id: 4,
      label: TemplateTypes.TERMSHEET,
      value: TemplateTypes.TERMSHEET,
    },
    {
      id: 5,
      label: TemplateTypes.POLICY,
      value: TemplateTypes.POLICY,
    },
    {
      id: 6,
      label: TemplateTypes.MOU,
      value: TemplateTypes.MOU,
    },
    {
      id: 7,
      label: TemplateTypes.OTHERS,
      value: TemplateTypes.OTHERS,
    },
  ]

  const DocumentSubmissionStatus = {
    AWAITING: formatMessage({id: 'Awaiting'}),
    OVERDUE: formatMessage({id: 'Overdue'}),
    CANCELLED: formatMessage({id: 'Cancelled'}),
    COMPLETED: formatMessage({id: 'Completed'}),
    EXPIRED: formatMessage({id: 'Expired'}),
  } as const

  const SignatureTypes = {
    WAITING_FOR_YOU: formatMessage({id: 'Waiting for You'}),
    WAITING_FOR_OTHERS: formatMessage({id: 'Waiting for Others'}),
  } as const

  const DocumentsStatusOptions = [
    {
      id: 1,
      label: DocumentSubmissionStatus.AWAITING,
      value: DocumentSubmissionStatus.AWAITING,
    },
    {
      id: 2,
      label: DocumentSubmissionStatus.OVERDUE,
      value: DocumentSubmissionStatus.OVERDUE,
    },
    {
      id: 3,
      label: DocumentSubmissionStatus.COMPLETED,
      value: DocumentSubmissionStatus.COMPLETED,
    },
    {
      id: 4,
      label: DocumentSubmissionStatus.CANCELLED,
      value: DocumentSubmissionStatus.CANCELLED,
    },
  ]

  const DocumentsSignatureStatusOptions = [
    {
      id: 1,
      label: SignatureTypes.WAITING_FOR_YOU,
      value: SignatureTypes.WAITING_FOR_YOU,
    },
    {
      id: 2,
      label: SignatureTypes.WAITING_FOR_OTHERS,
      value: SignatureTypes.WAITING_FOR_OTHERS,
    },
  ]

  return {
    DocumentsSignatureStatusOptions,
    DocumentsStatusOptions,
    TemplateTypeOptions,
  }
}
